import { render, staticRenderFns } from "./AddToProductsList.vue?vue&type=template&id=8a421190&"
import script from "./AddToProductsList.vue?vue&type=script&lang=js&"
export * from "./AddToProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports